/**
 * A CMS- or externally-supplied link as a safe href: absolute http(s) only, so
 * a `javascript:` or `data:` value can never render as a clickable link.
 * Returns null otherwise. The backend refuses such values on write too
 * (CmsController social links); this is the render-side half (ported from KeyzoStore).
 */
export function safeHttpUrl(raw: string | null | undefined): string | null {
  if (!raw) return null;
  try {
    const url = new URL(raw);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null;
  } catch {
    return null;
  }
}
